// Jadwal SPSE of a Penyedia paket (migration 0045): the schedule the intake
// read from the LPSE announcement, with the tahapan running today marked, and
// the stage move the schedule suggests (the user ticks it on the card; the API
// only ever moves a paket forward).
import { formatDeadline } from "./stages";

export interface JadwalItem {
  tahapan: string;
  mulai: string | null;
  sampai: string | null;
}

/** Today in Indonesia (WIB, UTC+7) as YYYY-MM-DD, the date the SPSE schedule is written in. */
export function jakartaToday(now: number = Date.now()): string {
  return new Date(now + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/** True when `today` lies within the row's dates. */
export function isRunning(item: JadwalItem, today: string): boolean {
  const start = item.mulai ?? item.sampai;
  const end = item.sampai ?? item.mulai;
  return start !== null && end !== null && start <= today && today <= end;
}

const day = (iso: string | null) => (iso ? formatDeadline(iso) : "-");

/** The schedule as a table; the running tahapan carries "Berjalan". */
export function JadwalTable({ jadwal, today = jakartaToday(), caption = "Jadwal tahapan SPSE" }: { jadwal: JadwalItem[]; today?: string; caption?: string }) {
  return (
    <div className="pkj-table" role="region" aria-label={caption} tabIndex={0}>
      <table>
        <caption className="pkj-caption">{caption}</caption>
        <thead>
          <tr>
            <th scope="col">Tahapan</th>
            <th scope="col">Mulai</th>
            <th scope="col">Sampai</th>
          </tr>
        </thead>
        <tbody>
          {jadwal.map((j, i) => {
            const running = isRunning(j, today);
            return (
              <tr key={`${j.tahapan}-${i}`} data-running={running ? "" : undefined}>
                <td>
                  {j.tahapan}
                  {running ? <span className="pkj-now">Berjalan</span> : null}
                </td>
                <td>{day(j.mulai)}</td>
                <td>{day(j.sampai)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

/** The suggested move on the card: why, and the box that asks for it. Nothing when there is no forward move to offer. */
export function StageSuggestion({
  suggestion,
  checked,
  disabled,
  onChange,
}: {
  suggestion: { value: string | null; raw: string } | null | undefined;
  checked: boolean;
  disabled: boolean;
  onChange: (on: boolean) => void;
}) {
  if (!suggestion?.raw) return null;
  return (
    <div className="pkj-suggest">
      <p className="pkj-reason">{suggestion.raw}</p>
      {suggestion.value === "pelaksanaan_pemilihan" ? (
        <label className="ppc-req">
          <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.currentTarget.checked)} />
          <span className="ppc-req-text">Pindahkan tahap project ke Pelaksanaan Pemilihan</span>
        </label>
      ) : null}
    </div>
  );
}
